<template>
  <div id="app_main">
    <span class="none">{{login_tag}}</span>
    <span class="none">{{wx_login_tag}}</span>
    <span class="none">{{kill_info}}</span>
    <span class="none">{{warn_info}}</span>
    <span class="none">{{is_update_user_info}}</span>
    <span class="none">{{is_update_kill}}</span>
    <router-view />

    <dlg ref="myForm_2"></dlg>
    <bindtel ref="myBindTel"></bindtel>

    <warn ref="formshow_warn"></warn>
    <kill_alert ref="show_kill"></kill_alert>

    <div class="none">
      <audio id="sound_match" controls="controls" style="display:none;">
        <source src="./assets/music/match_succ.wav" type="audio/mpeg" />
      </audio>
      <audio id="sound_receive" controls="controls" style="display:none;">
        <source src="./assets/music/receive_msg.wav" type="audio/mpeg" />
      </audio>
      <audio id="sound_send" controls="controls" style="display:none;">
        <source src="./assets/music/send_msg.wav" type="audio/mpeg" />
      </audio>
      <audio id="sound_keydown" controls="controls" style="display:none;">
        <source src="./assets/music/keydown.wav" type="audio/mpeg" />
      </audio>

    </div>
  </div>
</template>

<script>
  import { mapMutations, mapActions } from 'vuex';
  import Form from './components/Form.vue';
  import Bind from "./components/BindTel.vue";
  import * as tool from "./api/common";
  import Warn from "./components/Warning.vue";
  import Kill_Alert from "./components/Kill_Alert.vue";
  export default {
    components: {
      'dlg': Form,
      'bindtel': Bind,
      'warn': Warn,
      "kill_alert": Kill_Alert
    },
    data() {
      return {
        userinfo: {
          coin_left: 0,
        },
        reg_complete:''
      }
    },
    sockets: {
      login_rst: function (rst) {
        this.deal_login_rst(rst);
      }
    },
    computed: {
      //socket连接状态、业务登陆状态、socket登陆监控
      login_tag: function () {
        var connect = this.$store.state.connect; //权重：1
        var bll_login = this.$store.state.bll_login; //权重：10
        var socket_login = this.$store.state.socket_login; //权重：100
        var uid = this.$store.state.uid;
        console.log('监控登录状态:socket链接-->' + connect + ',业务登录-->'+bll_login + ',socket登录-->' + socket_login);

        var login_weigth = 0;
        if (connect) { login_weigth += 1; }
        if (bll_login) { login_weigth += 10; }
        if (socket_login) { login_weigth += 100; }

        if (connect && bll_login && !socket_login) {
          //登陆socket服务器
          this.login_socket(uid);
        }

        return login_weigth;
      },

      //微信登陆状态监控
      wx_login_tag: function () {
        var openid = '';

        var cookie_openid = this.$cookies.isKey('openid');
        if (cookie_openid) {
          openid = this.$cookies.get('openid');
        }

        if (!openid) {
          openid = this.$store.state.openid;
        }

        //业务登陆,核心目标是获取uid
        if (!this.$store.state.login) {
          this.login_bll(openid);
        }

        return openid;
      },

      //封号信息监控
      kill_info: function () {
        var newVal = this.$store.state.kill_info;
        if (newVal != "") {
          this.$refs.show_kill.show();
        }
        return newVal;
      },

      //警告信息监控
      warn_info: function () {
        var newVal = this.$store.state.warn_info;
        if (newVal != "") {
          this.show_warn(newVal);
        }
        return newVal;
      },

      //收否更新用户信息
      is_update_user_info() {
        var newVal = this.$store.state.objVal.is_update_user_info;
        if (newVal) {
          this.update_info();
        }
        return newVal;
      },
      //更新封号状态
      is_update_kill() {
        var newVal = this.$store.state.objVal.update_kill;
        if (newVal) {
          this.update_kill(newVal);
        }
        return newVal;
      }
    },
    watch: {

    },
    created() {
      //获取浏览设备信息
      var client_info = tool.get_client_info();
      this.$store.commit('set_client_info', client_info);

      //匹配手机本身的亮度模式
      var nightModeStatus = window.matchMedia('(prefers-color-scheme: dark)').matches;
      this.$store.commit('set_objVal', {"theme_dark" : nightModeStatus});
    },

    mounted() {
      this.init();
    },

    methods: {
      ...mapMutations(['get', 'post']), //引入方法
      ...mapActions(['act_get_userinfo',
        'act_push_mycomplain',
        'act_push_complainmy',
        'act_getFriend',
        'act_get_killinfo',
        "act_sub_coin",
        "act_reload_userinfo"
      ]), //引入方法

      init(){
        var self = this;
        self.get({
          url: '/App/GetConstData',
          success: function (data) {
            if(data){
              self.$store.commit('set_const_data', data);
            }
          }
        });

        self.get({
          url: '/App/GetSysDic/?uid=123',
          success: function (data) {

            if(data){
              console.log(JSON.stringify(data));
              self.$store.commit('set_sysdic', data);
            }
          }
        });
      },

      init_app(uid) {
        //加载拉黑信息
        this.act_push_mycomplain(uid);
        this.act_push_complainmy(uid);

        //加载好友列表
        this.act_getFriend(uid);

        //绑定手机号码提醒
        this.show_remind(uid);

        //获取封号信息
        this.act_get_killinfo(uid);

        //获取用户匹配次数
        this.get_match_count(uid);

        var self = this;
        //获取微信用户信息 2024.4.15号修改
        /**/
        setTimeout(() => {
          self.get_wxInfo(uid);
        }, 1000);


        //关注公众号提示 2024.4.15号修改
        /*
        setTimeout(() => {

          if(self.reg_complete == 1 || self.reg_complete == "1"){
            self.show_GuanzhuWx(uid);
          }

        }, 5000);
        */

        //获取离线数据(1小时内)
        setTimeout(() => {
          //console.log('获取离线数据1...');
          self.$socket.emit('get_off_msg', uid);
        }, 800);

        //获取离线数据(超过1小时)
        setTimeout(() => {
            //console.log('获取离线数据2...');
            self.get({
            url: '/App/GetMsgOff/?uid=' + uid,
            success: function (data) {
              //console.log(JSON.stringify(data));
              for(var i=0; i<data.length; i++){
                  self.$store.dispatch('act_push_message', data[i]);
              }
            }
          });

        }, 1000);

      },

      //登陆业务服务器，获取uid
      login_bll(openid) {

        //正式环境 （1==2）；测试环境（1==1）；
        if (1 == 2) {
          // 测试指定用户openid和uid
          var openid = 'or7AnwpkV4w86QF2N7aQDpIi1RT8';//静哥的账号id
          //wx_97WY78FPLRA8LQTM 小火柴官方
          //wx_K0611PXKB2CVDBOW 有好友数据-小乔uid
          //wx_PHH5SX3K7FWNYL5Q 没有好友数据
          //wx_716I3R4R2CH5LD3W 可查看语音账号
          //wx_F8TVAWGLM7KEZ6UI 正式环境下-静哥账号uid
          $cookies.set('uid', 'wx_F8TVAWGLM7KEZ6UI');
          $cookies.set('cookie_wxInfo', '');
          //统一模拟为非微信环境
          console.log('测试环境(业务登录-非微信端登录)...');
          this.login_bll_nowx();
          return false;
        }

        var client = this.$store.state.client;
        if (client.is_wx) {
          if (openid) {
            this.login_bll_wx(openid);
          }
        }
        else {
          this.login_bll_nowx();
        }
      },

      //微信环境登陆,获取uid
      login_bll_wx(openid) {
        var uid = '';
        if ($cookies.isKey('uid')) {
          uid = $cookies.get('uid');
        }
        var out_id = openid;
        var out_type = "微信公众号";
        this.login_bll_dtl(out_id, out_type, uid);
      },

      //非微信环境登陆,获取uid
      login_bll_nowx() {
        var uid = '';
        if ($cookies.isKey('uid')) {
          uid = $cookies.get('uid');
        }
        var out_id = '';
        var out_type = '非微信环境';
        this.login_bll_dtl(out_id, out_type, uid);
      },

      //业务登录，核心目标是获取用户信息
      login_bll_dtl(openid, out_type, cookie_uid) {
        console.log('cookie_uid:');
        console.log(cookie_uid);
        if(cookie_uid == null || cookie_uid == 'null'){
            cookie_uid = '';
        }
        var self = this;
        //2022.9.24分站标识
        var fz_tag = this.$store.state.fz_tag;
        console.log('分站id:' + fz_tag+ 'openid:' + openid + 'out_type:' + out_type + 'cookie_uid:' + cookie_uid );

        self.get({
           url: '/App/Login2/?out_id=' + openid + "&out_type=" + out_type + "&cookie_uid=" + cookie_uid + "&fz_tag=" + fz_tag, //正式系统需要这个东西
          //url: '/App/Login3/?uid=' + cookie_uid,
          success: function (u) {
            console.log(JSON.stringify(u));
            if(u.is_cancel){
               //toast 启动动画
               self.$loading('该用户已注销');
                return false;
            }
            if (u) {
              var uid = u.uid;
              $cookies.set('uid', uid, 30 * 24 * 60 * 60);
              self.$store.commit('set_uid', uid);
              self.$store.commit('push_userinfo', u);

              //注册是否完成标识 1==完成
              self.reg_complete = u.reg_complete;

              //初始化app
              self.init_app(uid);
            }
            else {
              self.show_GuanzhuWx_2();

              setInterval(function(){
                self.show_GuanzhuWx_2();
              }, 15000);
            }

          },
          error: function (err) {
          }
        });
      },

      //登陆socket服务器，设置socekt_id 和 uid的关系
      login_socket(uid) {
        this.$socket.emit('login', uid);
      },

      /* -----------socket 具体业务处理--------------- */
      deal_login_rst(data) {
        var self = this;

        if (data.tag == 'success') {
          self.$store.commit('set_socket_login', true);
        }

        var uid = self.$store.state.uid;
        if(this.reg_complete == 1 || this.reg_complete == "1" ){
          self.get({
            url: '/App/Set_Login_on/?uid=' + uid,
            success: function (data) {
              console.log("后台完成登录记录");
            },
            error: function (err) {
            }
          });
        }

      },

      //获取用户微信信息
      get_wxInfo(uid){
        //首先从缓存中获取，缓存中没有，再从后台获取
        if (this.$cookies.isKey('cookie_wxInfo')) {
            var wxInfo = this.$cookies.get('cookie_wxInfo');
            this.$store.commit('set_wxInfo', wxInfo);
            return true;
        }

        var self = this;
        this.get({
          url: "/Common/GetWxUserByUid/?uid=" + uid,
          success: function (data) {
            if(data.nickname || data.sex || data.headimgurl)
            {
              self.$store.commit('set_wxInfo', data);
              self.$cookies.set('cookie_wxInfo', data, 1 * 24 * 60 * 60);
            }
          },
          error: function (err) {},
        });
      },

      get_match_count(uid)
      {
          var self = this;
          self.get({
            url:"/App/GetUserMatchCount_2?uid=" + uid,
            success: function(data) {
              if (data) {
                self.$store.commit('set_objVal', {"match_rand" : parseInt(data.match_rand)});
                self.$store.commit('set_objVal', {"match_diff" : parseInt(data.match_diff)});
              }
            },
            error: function(res) {}
          });
      },

      //重新加载用户信息
      update_info() {
        var self = this;
        var uid = this.$store.state.uid;
        
        self.act_get_userinfo({
        uid: uid,
        success: function (u) {
          var age = u.age_range;
          var send_data = { age_range: age };
          self.save_userInfo(send_data);
        },
      });
      },
      save_userInfo(send_data) {
      //后台保存信息
      var self = this;
      var uid = this.$store.state.uid;
      //var send_data = {'nick' : nick};
      var data = {
        url: "/App/User_ModifyBaseInfo",
        data: {
          uid: uid,
          data: JSON.stringify(send_data),
        },
        success: function (data_serve) {
          if (data_serve.state == "1") {
            self.act_reload_userinfo({
              uid: uid,
              success: function (info) {
                self.$toast.center("你的个人信息刷新成功");
              },
            });
          }
        },
      };
      self.post(data);
    },

      update_kill(to_uid) {
        if (to_uid) {
          var self = this;
          this.act_get_userinfo({
                uid: to_uid,
                success: function (u) {
                    u.is_kill = 1;
                    self.$store.commit('push_userinfo', u);
                }
          });
        }
        
      },

      //显示提示信息：绑定手机号码提示、女生用户挣钱提示
      show_remind(uid) {
        var self = this;
        this.act_get_userinfo({
          uid: uid,
          success: function (u) {
            var vip_level = u.vip_level;
            var coin_left = u.coin_left;
            var score_left = u.score_left;
            var is_bindtel = u.tel;

            self.userinfo.coin_left = u.coin_left;

            var msg = '为了防止您的信息丢失，请绑定手机号码，如遇信息丢失，后续可通过该手机号码找回丢失的信息。平台郑重承诺，在未经您本人同意的情况下，我们不会泄露您的任何信息。'
            var msg_tag = '';
            if (vip_level) {
              msg_tag += '您是尊贵的会员用户，'
            }
            if (coin_left) {
              msg_tag += '您有金币，'
            }
            if (score_left) {
              msg_tag += '您有积分，'
            }

            if (msg_tag && !is_bindtel) {
              msg = '系统检测到' + msg_tag + msg;
              self.show_remind_bindTel(msg);
            }
          }
        });
      },

      //关注公众号提示
      show_GuanzhuWx(uid) {
        var skipWxCheck = this.$store.state.skipWxCheck;
        if(!skipWxCheck) {
          var wxInfo = this.$store.state.wxInfo;
          if(wxInfo == '')
          {
            this.show_sys_GuanzhuWx();
          }
        }

      },

      show_remind_bindTel(msg) {
        var h = '<div style="font-size: 0.9rem;line-height: 1.6em;color: #888;">' + msg + '</div>';
        this.$refs.myBindTel.show(h, {
          type: "alert",
          confirmText: "立即绑定",
          titleText: "绑定手机号码",
          data: ""
        });
      },
      
      hidden_remind_bindTel(){
        this.$refs.myBindTel.hidden();
      },

      //关注公众号提示
      show_sys_GuanzhuWx() {
                var qrcode_url = require('./assets/img/qrcode_xhc.jpg');
                var gzh_name = '小火柴';
                //加载dic信息
                var sysdic = this.$store.state.sysdic;
                if(sysdic){
                    qrcode_url = sysdic.wx_gzh_qrcode;
                    gzh_name = sysdic.wx_gzh_name;
                }

                var h = '<div style="line-height:1.6em; font-size: 0.9rem; color: #888;">尊敬的用户，小火柴系统已升级到最新版本，您当前所在的系统过于老旧，很多功能无法体验，请关注微信公众号【'+ gzh_name +'】，体验更多新功能~<div>'
                    + '<div class="ub ub-ac ub-pc dlg-img"><img src="' + qrcode_url + '" style="margin: 1rem 0"/></div>'
                    + '<div style="line-height:1.6em; text-align:center;">长按解锁特权功能<div>'
        this.$refs.myForm_2.show(h, {
          type: 'alert',
          confirmText: '长按上方二维码',
          titleText: '温馨提示',
          data: ''
        });
      },

      show_GuanzhuWx_2() {
                var qrcode_url = require('./assets/img/qrcode_xhc.jpg');
                var gzh_name = '小火柴';
                //加载dic信息
                var sysdic = this.$store.state.sysdic;
                if(sysdic){
                    qrcode_url = sysdic.wx_gzh_qrcode;
                    gzh_name = sysdic.wx_gzh_name;
                }

                var h = '<div style="line-height:1.6em; text-align: center; font-size: 0.9rem; color: #888;">为了保障您的聊天体验，当前只支持微信环境下聊天，请先关注微信公众号【'+ gzh_name +'】<div>'
                    + '<div class="ub ub-ac ub-pc dlg-img"><img src="' + qrcode_url + '" /></div>'
                    + '<div style="line-height:1.6em; text-align:center;">更多特权等你来~<div>'
                this.$refs.myForm_2.show(h, {
                    type: 'alert',
                    confirmText: '微信扫描上方二维码',
                    titleText: '温馨提示',
                    data: ''
                });
      },

      //警告弹窗
      show_warn(warn_sec) {
        var ctxt = '<div style=" width: 100%; font-size:.9rem;">你的账号被投诉次数过多，即将触发平台封号机制，请文明聊天，聊天过程请不要收到投诉举报/拉黑等情况，以免影响你正常聊天交友，感谢你的配合</div>';
        this.$refs.formshow_warn.show(ctxt, {
          confirmText: "立即兑换",
          titleText: "警告",
          timeout: warn_sec,
        });
      },
    }
  }
</script>

<style lang="scss">
  #app_main {
    margin: 0;
    padding: 0;
  }

  .note {
    font-size: .9em;
    color: #666;
    line-height: 1.8em;
  }

  .info {
    background-color: white;
    height: 7em;
    padding: .5em;
  }

  .head_picture {
    width: 4em;
    height: 4em;
    background-color: #bcbcbc;
    border-radius: 50%;
  }

  .nick {
    font-size: 0.9em;
    color: #333;
    margin-top: .5em;
  }

  .sex_img {
    width: 1.5em;
    height: 1.2em;
    margin-top: .5em;
  }

  .location_img {
    width: 1em;
    height: 1em;
    margin-left: .25em;
    margin-top: .8em;
  }

  .font_Sex_Age {
    height: 1.2em;
    margin-top: .5em;
  }

  .font_sex {
    height: 1.5em;
    line-height: 1.5em;
    color: #333;
    font-size: .9em;
  }

  .font_Age {
    justify-content: center;
    height: 1.5em;
    line-height: 1.5em;
    color: #333;
    font-size: .9em;
  }

  .font_province_city {
    height: 1.5em;
    margin-top: .55em;
  }

  .font_province {
    color: #333;
    line-height: 1.5em;
    font-size: 14px;
  }

  .font_city {
    color: #333;
    line-height: 1.5em;
    font-size: 14px;
    margin-left: .8em;
  }

  .info_left_icon {
    margin-left: .5em;
  }

  .div_label {
    margin-top: .7em;
  }

  .label {
    display: inline-block;
    font-size: .75em;
    height: 1em;
    line-height: 1em;
    padding: 0.2em;
    border-radius: .3em;
    background-color: #e92162;
    font-size: .6em;
    color: white;
    margin-right: .3em;

  }
</style>
